import { Button, Divider, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { APP_ICONS } from "../../assets";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import DynamicTable from "../../components/dynamicTable";
import Loader from "../../components/loader";
import NavigationDrawer from "../../components/navigationDrawer";
import SelectInput from "../../components/select";
import TextInput from "../../components/textInput";
import { createFaq, deleteFaq, fetchFaq, updateFaq } from "../../services/Faq";
import { constants } from "../../theme/Variables";
import FaqCustomDialog from "./CreateFaqDiaLog";

const tableHeader = [
  "Faq#ID",
  "Faq_Title",
  "Faq_Description",
  "Created_At",
  "Actions",
];
const displayRows = [
  "_id",
  "Faq_Title",
  "Faq_Description",
  "created_at",
  "actions",
];
const selectInputWidth = { width: { xs: "100%", md: "150px" } };

function Faq() {
  const openFaqDialog = useRef();
  const [searchValue, setSearchValue] = useState("");
  const [allFaq, setAllFaq] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dialogType, setDialogType] = useState("add");
  const [inputValues, setInputValues] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    handleFetchAllFaq();
  }, []);

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({ snackType: type, snackMessage: message });
  };

  const handleFetchAllFaq = async () => {
    setIsLoading(true);
    try {
      const response = await fetchFaq();
      if (response.status === 200 || response.status === 201) {
        setAllFaq(response?.data?.data || []);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFaqOperation = async (data, type) => {
    setIsLoading(true);
    try {
      const payload = {
        title: inputValues.title,
        description: inputValues.description,
      };
      const response =
        type === "edit"
          ? await updateFaq(data?._id, payload)
          : await createFaq(payload);
      response.status === 200 || response.status === 201
        ? handleOpenSnackBar("success", response.data.message)
        : handleOpenSnackBar("error", response.data.message);
      openFaqDialog.current.closeDialog();
      handleFetchAllFaq();
    } catch (error) {
      handleOpenSnackBar("error", error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteFaq = async (element) => {
    setIsLoading(true);
    try {
      const response = await deleteFaq(element);
      response.status === 200 || response.status === 201
        ? handleOpenSnackBar("success", response.data.message)
        : handleOpenSnackBar("error", response.data.message);
      handleFetchAllFaq();
    } catch (error) {
      handleOpenSnackBar("error", error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDialog = (type, row = { title: "", description: "" }) => {
    setDialogType(type);
    setInputValues(row);
    openFaqDialog.current.openDialog(row);
  };

  return (
    <NavigationDrawer>
      <CustomBar title="FAQ's" />
      <AppContainer>
        <Stack
          direction={{ sm: "row" }}
          width="100%"
          flex={2}
          p={2}
          gap={2}
          justifyContent={{ md: "flex-end" }}
        >
          <Button
            variant="contained"
            onClick={() => handleOpenDialog("add")}
            sx={{ height: 37, width: 100 }}
          >
            Add
          </Button>
        </Stack>
        <Divider />
        {allFaq.length > 0 ? (
          <DynamicTable
            tableData={allFaq}
            displayRows={displayRows}
            tableHeader={tableHeader}
            handleEdit={(row) => handleOpenDialog("edit", row)}
            handleDelete={handleDeleteFaq}
            showEditAndDelete={true}
            showEdit={true}
            showDelete={true}
            showPagination={true}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign="center"
            padding="30px 0"
          >
            No FAQ's Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
      <FaqCustomDialog
        ref={openFaqDialog}
        dialogType={dialogType}
        handleCreate={handleFaqOperation}
        inputValues={inputValues}
        handleChange={(field, value) =>
          setInputValues((prev) => ({ ...prev, [field]: value }))
        }
        // handleCreate={}
      />
    </NavigationDrawer>
  );
}

export default Faq;
